import { Link } from 'react-router'
import { isMakerDirectoryEnabled } from '@/lib/makers'

export function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer className="border-t border-gray-100 bg-white">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-6 text-xs text-gray-500">
        <span>&copy; {year} T6. All rights reserved.</span>
        <nav className="flex items-center gap-4">
          <Link to="/pricing" className="hover:text-black hover:underline">
            Pricing
          </Link>
          {/* The navbar's link row is hidden below md — this keeps the maker
              directory reachable on mobile. */}
          {isMakerDirectoryEnabled() && (
            <Link to="/makers" className="hover:text-black hover:underline">
              Find a Maker
            </Link>
          )}
          <a href="/terms" className="hover:text-black hover:underline">
            Terms
          </a>
          <a href="/privacy" className="hover:text-black hover:underline">
            Privacy
          </a>
        </nav>
      </div>
    </footer>
  )
}
